var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExplicit = function SvgExplicit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "explicit_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    stroke: "#707070",
    "data-name": "Rectangle 1016",
    transform: "translate(1277 744)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#explicit_svg__a)",
    "data-name": "Mask Group 1571",
    transform: "translate(-1277 -744)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2926"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f6145a",
    d: "M1312.36 820.998a37.22 37.22 0 0 1-33.1-40.867 37.23 37.23 0 0 1 40.872-33.1 5.815 5.815 0 0 1 5.174 6.393 5.81 5.81 0 0 1-6.388 5.174 25.59 25.59 0 0 0-28.1 22.748 25.59 25.59 0 0 0 22.753 28.092 25.59 25.59 0 0 0 28.092-22.748 5.815 5.815 0 0 1 6.388-5.174 5.807 5.807 0 0 1 5.174 6.387 37.24 37.24 0 0 1-36.95 33.3 38 38 0 0 1-3.915-.205m24.64-48.473v-5h-5a3.5 3.5 0 0 1-3.5-3.5 3.5 3.5 0 0 1 3.5-3.5h5v-5a3.5 3.5 0 0 1 3.5-3.5 3.505 3.505 0 0 1 3.5 3.5v5h5a3.5 3.5 0 0 1 3.5 3.5 3.5 3.5 0 0 1-3.5 3.5h-5v5a3.5 3.5 0 0 1-3.5 3.5 3.5 3.5 0 0 1-3.497-3.499Z",
    "data-name": "Union 18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#485766",
    d: "M1305.74 795.349h4.884v-22.671h-3.894l-6.8 4.554 1.947 3.432 3.861-2.409Zm17.717.4c4.983 0 9.108-2.343 9.108-6.468 0-2.607-1.782-4.587-4.455-5.643 2.277-.99 3.894-2.64 3.894-5.181 0-3.894-4.026-6.171-8.547-6.171-4.422 0-8.514 2.178-8.514 6.171 0 2.574 1.617 4.224 3.861 5.181-2.607.99-4.455 2.97-4.455 5.643.008 4.088 4.096 6.468 9.108 6.468m0-13.794c-1.782-.132-3.663-1.122-3.663-2.871 0-1.551 1.485-2.706 3.663-2.706s3.7 1.155 3.7 2.706c0 1.679-1.914 2.735-3.7 2.865Zm0 9.7c-2.409 0-4.158-1.188-4.158-2.9 0-1.782 2.211-2.9 4.158-2.97 1.951.064 4.2 1.182 4.2 2.964 0 1.716-1.787 2.9-4.2 2.9Z",
    "data-name": "Path 6112"
  })))));
};
export default SvgExplicit;